var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 32,
    viewBox: "0 0 41 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4981 7.47042C12.834 8.09766 12.834 9.11459 13.4981 9.74183L19.595 15.5L13.4981 21.2582C12.834 21.8854 12.834 22.9024 13.4981 23.5296C14.1622 24.1568 15.239 24.1568 15.9031 23.5296L22 17.7713L28.097 23.5296C28.761 24.1568 29.8379 24.1568 30.5019 23.5296C31.166 22.9024 31.166 21.8854 30.5019 21.2582L24.405 15.5L30.5019 9.74184C31.166 9.11462 31.166 8.09767 30.5019 7.47045C29.8377 6.84321 28.761 6.84321 28.097 7.47045L22 13.2286L15.9031 7.47042C15.239 6.84319 14.1622 6.84319 13.4981 7.47042Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d1591ef1b438b238f3cd4cb2196562fe.svg";
export { ForwardRef as ReactComponent };